import React from 'react'

const WizardSwitch = ({ children, ...props }) => {
  return React.Children.map(children, (child, i) => {
    const { test } = child.props

    if (!test()) return null

    return React.cloneElement(child, props)
  })
}

export default WizardSwitch



// WEBPACK FOOTER //
// ./src/components/Wizard/WizardSwitch.js